import ApiEndpoints from "@app/utils/ApiEndpoints";
import axios from "@app/Security/AxiosAuthentication";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class EzFeedHelper {

    /**
     * Soap is formatted using SOAP 1.2
     * Parameters
     * 0 = method: RetrieveHistoricalQualityData | RetrieveQualityData
     * 1 = UserName
     * 2 = Password
     */
    static soapTemplate = `<?xml version="1.0" encoding="utf-8"?>
<soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
    <soap12:Body>
    <{method} xmlns="http://nwdairy.coop/">
        <UserName>{username}</UserName>
        <Password>{password}</Password>
    </{method}>
    </soap12:Body>
</soap12:Envelope>
`;

    /**
     * see: https://ezfeed.nwdairy.coop/dataconnect.asmx?op=RetrieveHistoricalQualityData
     * 
     * @param username 
     * @param password 
     */
    static getHistoricalQualityData = async (username: string, password: string): Promise<[string, boolean]> => {

        const url: string = ApiEndpoints.EZ_FEED_WSDL_URL ?? "";

        let xml = EzFeedHelper.soapTemplate;

        let hasAccess = false;

        let message = "Access denied";

        xml = xml.replace(/\{method\}/g, "RetrieveHistoricalQualityData");

        xml = xml.replace(/\{username\}/g, username.trim() );

        xml = xml.replace(/\{password\}/g, password.trim() );

        const options = {
            headers: {
                "Content-Type": "application/soap+xml; charset=utf-8"
            }
        };

        try {
       
            const response = await axios.post(url, xml, options);

            const xmlParser = new DOMParser();

            const xmlData = xmlParser.parseFromString(response.data, "application/xml");

            const tables = xmlData.querySelectorAll("Table");

            if (tables) {

                console.info("table count", tables.length);
                
                message = `Historical Quality Data Rows Returned: ${tables.length}`;

            } else {

                message = `Historical Quality Data Rows Returned: 0`;

            }

            hasAccess = true;
            
        } catch (error) {

            RollbarHelper.logRequestError(error, "getHistoricalQualityData()");
            
        }

       return [message, hasAccess];

    }

    /**
     * see: https://ezfeed.nwdairy.coop/dataconnect.asmx?op=RetrieveQualityData
     * 
     * @param username 
     * @param password 
     */
     static getQualityData = async (username: string, password: string): Promise<[string, boolean]> => {

        const url: string = ApiEndpoints.EZ_FEED_WSDL_URL ?? "";

        let xml = EzFeedHelper.soapTemplate;

        let hasAccess = false;

        let message = "Access denied";

        xml = xml.replace(/\{method\}/g, "RetrieveQualityData");

        xml = xml.replace(/\{username\}/g, username.trim() );

        xml = xml.replace(/\{password\}/g, password.trim() );

        const options = {
            headers: {
                "Content-Type": "application/soap+xml; charset=utf-8"
            }
        };

        try {
       
            const response = await axios.post(url, xml, options);

            const xmlParser = new DOMParser();

            const xmlData = xmlParser.parseFromString(response.data, "application/xml");

            const tables = xmlData.querySelectorAll("Table");

            if (tables) {

                console.info("table count", tables.length);
                
                message = `Quality Data Rows Returned: ${tables.length}`;

            } else {

                message = `Quality Data Rows Returned: 0`;

            }

            hasAccess = true;
            
        } catch (error) {

            RollbarHelper.logRequestError(error, "getQualityData()");
            
        }

       return [message, hasAccess];

    }

}